// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__P2WEq","header":"ReportDetails_header__3Z3R5","title":"ReportDetails_title__w8Vfi","left":"ReportDetails_left__26Ib4"};